!(function () {
  "use strict";
  customElements.get("quantity-counter") ||
    customElements.define(
      "quantity-counter",
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            (this.buttonClickEvent = this.onButtonClick.bind(this)),
            (this.onQuantityChangeEvent = this.onQuantityChange.bind(this)),
            this.input.addEventListener("change", this.onQuantityChangeEvent),
            this.querySelectorAll("button").forEach((t) =>
              t.addEventListener("click", this.buttonClickEvent)
            );
          
          // Store the original unit price when component loads
          this.originalUnitPriceCents = this.getOriginalUnitPriceCents();
          console.log('Original unit price stored:', this.originalUnitPriceCents);
        }
        onButtonClick(t) {
          t.preventDefault();
          const e = this.input.value,
            n =
              "BUTTON" == t.target.nodeName
                ? t.target
                : t.target.closest("button");
          "increase" === n.name && this.input.stepUp(),
            "decrease" === n.name && this.input.stepDown(),
            e !== this.input.value &&
              (this.input.dispatchEvent(this.changeEvent), this.updateAddToCartPrice());
        }
        onQuantityChange() {
          "updates[]" == this.input.name && this.updateCart();
          this.updateAddToCartPrice();
        }
        updateCart() {
          "" !== this.quantityValue &&
            this.dispatchEvent(
              new CustomEvent("theme:cart:update", {
                bubbles: !0,
                detail: {
                  id: this.input.dataset.id,
                  quantity: this.input.value,
                },
              })
            );
        }
        getOriginalUnitPriceCents() {
          const form = this.closest('form[action*="/cart/add"]');
          if (!form) return null;
          const variantEl = form.querySelector('[name="id"]');
          
          // Try to get from data-product-json first (most reliable)
          try {
            const jsonNode = form.querySelector('[data-product-json]');
            if (jsonNode && variantEl?.value) {
              const data = JSON.parse(jsonNode.textContent);
              const v = data.variants?.find(v => String(v.id) === String(variantEl.value));
              if (v?.price != null) return parseInt(v.price, 10);
            }
          } catch(e) {
            console.error('Error parsing product JSON for unit price:', e);
          }
          
          // Fallback: Get from data-price attribute
          const priced = form.querySelector('[data-price]');
          if (priced && priced.dataset.price) return parseInt(priced.dataset.price, 10);
          
          // Fallback: Get from data-product-price textContent (initial value only)
          const moneyNode = form.querySelector('[data-product-price],[data-product-price-target],[data-current-price]');
          if (moneyNode) {
            return this.parseMoneyToCents(moneyNode.textContent);
          }
          
          return null;
        }
        
        parseMoneyToCents(str) {
          if (!str) return null;
          const norm = String(str).replace(/[^\d.,]/g, '').replace(',', '.');
          const val = parseFloat(norm);
          return isNaN(val) ? null : Math.round(val * 100);
        }
        
        updateAddToCartPrice() {
          console.log('updateAddToCartPrice called from web component');
          const form = this.closest('form[action*="/cart/add"]');
          if (!form) {
            console.log('No form found');
            return;
          }
          const submitBtn = form.querySelector('button[type="submit"], .product-form__submit, .btn--add-to-cart');
          if (!submitBtn) {
            console.log('No submit button found');
            return;
          }
          
          function formatCents(cents) {
            const currency = (document.querySelector('meta[itemprop="priceCurrency"]')?.content) || 'AED';
            // Format as "300.00 AED" instead of "AED 300.00"
            return (cents / 100).toFixed(2) + ' ' + currency;
          }
          
          // Use the stored original unit price (never changes)
          const unit = this.originalUnitPriceCents;
          console.log('Unit price from web component (stored):', unit);
          if (unit == null) return;
          const qty = Math.max(1, parseInt(this.input.value || '1', 10));
          console.log('Quantity from web component:', qty);
          const total = unit * qty;
          console.log('Total from web component:', total);
          const priceSpan = submitBtn.querySelector('[data-btn-price], [data-product-price]');
          console.log('Price span found in web component:', priceSpan);
          if (priceSpan) {
            priceSpan.textContent = formatCents(total);
            console.log('Updated price span to:', formatCents(total));
          } else {
            submitBtn.textContent = `ADD TO CART — ${formatCents(total)}`;
            console.log('Updated button text to:', `ADD TO CART — ${formatCents(total)}`);
          }
        }
      }
    );
})();
